import { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { forgotPassword } from "../core/_requests.ts";
import MaterialButton from "../../../components/MaterialButton";
import {
  TextField,
  Card,
  CardContent,
  Typography,
  Button,
  InputAdornment,
  Box,
} from "@mui/material";
import { MailIcon } from "../../../Icons/MailIcon.jsx";
import { useNavigate } from "react-router-dom";
import MaterialInput from "../../../components/MaterialInput";

const initialValues = {
  email: "",
};

const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("Wrong email format")
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Email is required"),
});

export default function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const [hasErrors, setHasErrors] = useState(undefined);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues,
    validationSchema: forgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      setHasErrors(undefined);
      // setTimeout(() => {
      forgotPassword(values.email)
        .then((res) => {
          console.log("data from mail", res?.resetPasswordMail?.success);
          if (res?.resetPasswordMail?.success) {
            setHasErrors(false);
            setMessage(res?.resetPasswordMail?.message);
            setLoading(false);
          } else {
            setHasErrors(true);
            setMessage(res?.resetPasswordMail?.message);
            setLoading(false);
          }
        })
        .catch(() => {
          setHasErrors(true);
          setLoading(false);
          setSubmitting(false);
          setStatus("Sorry, there was an issue. Please try again.");
        });
      // }, 1000);
    },
  });

  // const handelSubmit =()=>{

  // }

  return (
    <section
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "#f8f9fa",
        padding: "1rem",
      }}
    >
      <Card
        sx={{
          width: "100%",
          maxWidth: 420,
          padding: 4,
          borderRadius: 4,
          boxShadow: "0 8px 30px rgba(0, 0, 0, 0.2)",
          background: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(10px)",
        }}
      >
        <CardContent>
          {/* Title */}
          <Typography
            variant="h4"
            component="h2"
            align="center"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: "#3F51B5",
              marginBottom: 3,
              textShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            Forgot Password?
          </Typography>

          {/* Subtitle */}
          { (hasErrors !==true && hasErrors !==false) &&
            <Typography
              variant="body1"
              align="center"
              sx={{
                marginBottom: 3,
                color: "#6c757d",
                fontSize: "16px",
                lineHeight: 1.6,
              }}
            >
              Enter your email address, and we’ll send you instructions to reset
              your password.
            </Typography>
          }

          {/* Error or Success Message */}
          {hasErrors === true && (
            <Typography
              variant="body2"
              color="error"
              align="center"
              gutterBottom
              sx={{ marginBottom: 2 }}
            >
              {message}
            </Typography>
          )}
          {hasErrors === false && (
            <Typography
              variant="body2"
              color="success.main"
              align="center"
              gutterBottom
              sx={{ marginBottom: 2 }}
            >
              {message}
            </Typography>
          )}

          {/* Form */}
          <form onSubmit={formik.handleSubmit} noValidate>
            {/* Input Field */}
            <div style={{ marginBottom: "1.5rem" }}>
              <MaterialInput
                placeholder="Enter your email"
                variant="outlined"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MailIcon className="text-2xl text-default-400" />
                    </InputAdornment>
                  ),
                }}
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              />
            </div>

            {/* Buttons */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                marginBottom: "1rem",
              }}
            >
              <MaterialButton
                type="submit"
                variant="contained"
                color="dark"
                // sx={{
                //   backgroundColor: "#3F51B5",

                //   fontWeight: "bold",
                //   padding: "12px 20px",
                //   borderRadius: "8px",
                //   "&:hover": { backgroundColor: "#303F9F" },
                //   transition: "background-color 0.3s ease",
                // }}
                disabled={loading || !formik.isValid}
              >
                {loading ? (
                  <span
                    className="indicator-progress"
                    style={{ display: "block" }}
                  >
                    Please wait...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                ) : (
                  "Submit"
                )}
              </MaterialButton>
              <Button
                type="button"
                variant="outlined"
                sx={{
                  color: "#3F51B5",
                  borderColor: "#3F51B5",
                  fontWeight: "bold",
                  padding: "12px 20px",
                  borderRadius: "8px",
                  "&:hover": { borderColor: "#303F9F", color: "#303F9F" },
                }}
                onClick={() => navigate("/")}
              >
                Cancel
              </Button>
            </Box>

            {/* Form Status */}
            {formik.status && (
              <Typography
                variant="body2"
                color="error"
                align="center"
                gutterBottom
                sx={{ marginTop: 2 }}
              >
                {formik.status}
              </Typography>
            )}
          </form>
        </CardContent>
      </Card>
    </section>
  );
}
